import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { CreditCard, LockKeyhole, Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import heroCreator from "@/assets/hero-creator.jpg";

const Index = () => {
  const { loading, user } = useAuth();

  if (loading) return null;
  if (user) return <Navigate to="/feed" replace />;

  const benefits = [
    { icon: CreditCard, label: "Creator subscriptions" },
    { icon: Sparkles, label: "Direct fan tips" },
    { icon: LockKeyhole, label: "Exclusive SFW content" },
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="JoinBADDY — SFW Creator Platform for Verified Creators"
        description="JoinBADDY is a safe-for-work platform where verified creators earn from subscriptions, tips, and exclusive content. Payments processed securely by Stripe."
        path="/"
      />
      <Navbar />
      <main>
        <section className="relative min-h-[calc(100vh-3rem)] overflow-hidden pt-16 flex items-center">
          <img
            src={heroCreator}
            alt="Verified creator on JoinBADDY"
            className="absolute inset-0 h-full w-full object-cover object-center opacity-45"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/85 to-background/35" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/30" />
          <div className="container relative z-10 mx-auto px-4 py-20">
            <div className="max-w-3xl">
              <p className="mb-5 text-sm font-semibold uppercase text-primary">100% safe-for-work</p>
              <h1 className="text-5xl sm:text-7xl font-heading font-bold leading-none">JoinBADDY</h1>
              <p className="mt-5 text-xl sm:text-2xl text-foreground/85">The SFW platform for verified creators</p>
              <ul className="mt-10 grid max-w-2xl gap-4 sm:grid-cols-3">
                {benefits.map(({ icon: Icon, label }) => (
                  <li key={label} className="flex items-center gap-3 border-t border-border/70 pt-4 text-sm font-medium">
                    <Icon className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
                    {label}
                  </li>
                ))}
              </ul>
              <div className="mt-10 flex flex-col gap-3 sm:flex-row">
                <Button asChild variant="hero" size="lg">
                  <Link to="/explore">Explore creators</Link>
                </Button>
                <Button asChild variant="outline" size="lg">
                  <Link to="/create">Get Started</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
